import * as yup from 'yup'
import { confirmPasswordValidationSchema, passwordValidationSchema } from './singleFieldsValidationSchemas'

const validationSchema = yup.object().shape({
  confirmPassword: confirmPasswordValidationSchema('newPassword'),
  currentPassword: yup.string().required(),
  newPassword: passwordValidationSchema,
})
export default validationSchema
